import { defaultCreateForm } from '../constants/formConfig';

export function getClientLabel(option = {}) {
  const baseName = option.alias || option.empresa || 'Sin nombre';
  const detail = option.nombreComercial ? ` · ${option.nombreComercial}` : '';
  const code = option.idCliente ? ` (${option.idCliente})` : '';
  return `${baseName}${detail}${code}`;
}

function getFirstTextValue(fields = {}) {
  return (
    Object.values(fields).find(value => typeof value === 'string' && value.trim()) || ''
  );
}

const LABEL_CANDIDATE_KEYS = [
  'Nombre',
  'Nombre SAT',
  'Descripción',
  'Descripcion',
  'Concepto',
  'Uso CFDI',
  'Uso del CFDI',
  'Régimen',
  'Regimen',
  'Clave',
  'Clave SAT',
  'ID',
  'Código',
  'Codigo',
  'Name'
];

const CODE_FIELD_KEYS = [
  'Código',
  'Codigo',
  'Clave',
  'Clave SAT',
  'Clave SAT (Catálogo)',
  'Number',
  'Número',
  'Numero',
  'Code',
  'Uso del CFDI',
  'Uso CFDI',
  'ID CFDI'
];

const TIPO_FIELD_KEYS = [
  'Tipo de contribuyente',
  'Tipo contribuyente',
  'Tipo persona',
  'Tipo',
  'Tipo cliente',
  'Tipo régimen',
  'Tipo régimen fiscal',
  'Tipo Régimen fiscal'
];

function getFieldValueByKeys(fields = {}, keys = []) {
  for (const key of keys) {
    if (!(key in fields)) continue;
    const value = fields[key];
    if (value === undefined || value === null) continue;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed) return trimmed;
    }
    if (typeof value === 'number') {
      return String(value);
    }
  }
  return '';
}

export function buildLinkedOptionLabel(fields = {}) {
  for (const key of LABEL_CANDIDATE_KEYS) {
    const value = getFieldValueByKeys(fields, [key]);
    if (value) return value;
  }
  return getFirstTextValue(fields) || 'Sin nombre';
}

export function mapLinkedRecords(records = []) {
  return records
    .map(record => {
      const fields = record.fields || {};
      const label = buildLinkedOptionLabel(fields);
      if (!label) return null;
      let code = getFieldValueByKeys(fields, CODE_FIELD_KEYS);
      if (code && typeof code === 'string' && code.includes('-')) {
        const [firstSegment] = code.split('-');
        const trimmedSegment = firstSegment.trim();
        if (/^[A-Za-z0-9]+$/.test(trimmedSegment)) {
          code = trimmedSegment;
        }
      }
      const tipo = getFieldValueByKeys(fields, TIPO_FIELD_KEYS);
      const displayLabel = code ? `${code} · ${label}` : label;
      const searchTokens = [
        label,
        code,
        displayLabel,
        tipo,
        ...Object.values(fields).filter(value => typeof value === 'string')
      ];
      const searchValue = searchTokens
        .filter(Boolean)
        .map(value => value.toLowerCase())
        .join(' ');
      return {
        id: record.id,
        label,
        code,
        tipo,
        displayLabel,
        searchValue
      };
    })
    .filter(Boolean);
}

export function getCreateFormDefaults() {
  return {
    ...defaultCreateForm,
    constanciaFiles: [],
    ticketFiles: []
  };
}
